import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { useEditContext } from 'react-admin';

import { ProviderAccountsForm } from '../components/ProviderAccountsForm/ProviderAccountsForm';
import { ProviderAccountsFormSkeleton } from '../components/ProviderAccountsForm/ProviderAccountsFormSkeleton';

export const ProviderAccountsEditForm = () => {
  const { isLoading } = useEditContext();
  const { ready } = useNormalizeReferences({
    referenceFields: ['company', 'provider', 'workTeam', 'merchants'],
  });

  if (isLoading || !ready) {
    return <ProviderAccountsFormSkeleton />;
  }

  return <ProviderAccountsForm />;
};
